/**
 * @constructor
 *
 * @param {string} [driverRef]
 * @param {?string} [printerName]
 */
const PrintRouting = function (driverRef, printerName) {
    /**
     * @type {!string}
     */
    this.driverRef = driverRef || null;

    /**
     * @type {?string}
     */
    this.printerName = printerName || null;
};

module.exports = PrintRouting;
